import { render } from "./Web.vue?vue&type=template&id=c76d14b8&scoped=true&bindings={\"name\":\"props\",\"emitClick\":\"options\"}"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import "./Web.vue?vue&type=style&index=0&id=c76d14b8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c76d14b8"

export default script